export function buildPanelsPageQueryV1(projectId: number)
{
	return {
		'$type': 'TCh.Domain.Evaluation.Estimations.Queries.PanelsPageQueryV1, TCh.Domain.Evaluation',
		'ProjectId': projectId,
	}
}

export function buildPanelistsPageQueryV1(surveyId: number)
{
	return {
		'$type': 'TCh.Domain.Evaluation.Estimations.Queries.PanelistsPageQueryV1, TCh.Domain.Evaluation',
		'SurveyId': surveyId,
	}
}

export function buildMeetingManagerPageQueryV1(surveyId: number)
{
	return {
		'$type': 'TCh.Domain.Evaluation.Estimations.Queries.MeetingManagerPageQueryV1, TCh.Domain.Evaluation',
		'SurveyId': surveyId,
	}
}

export function buildPanelistDashboardPageQueryV1(workspaceId: number, surveyId: number, projectUserId: number)
{
	return {
		'$type': 'TCh.Domain.Evaluation.Estimations.Queries.PanelistDashboardPageQueryV1, TCh.Domain.Evaluation',
		'WorkspaceId': workspaceId,
		'SurveyId': surveyId,
		'ProjectUserId': projectUserId
	}
}

export function buildPanelistAlternativePageQueryV1(workspaceId: number, surveyId: number, projectUserId: number, alternativeId: number)
{
	return {
		'$type': 'TCh.Domain.Evaluation.Estimations.Queries.PanelistAlternativePageQueryV1, TCh.Domain.Evaluation',
		'WorkspaceId': workspaceId,
		'SurveyId': surveyId,
		'ProjectUserId': projectUserId,
		'AlternativeId': alternativeId,
	}
}

export function buildPanelistMeetingPageQueryV1(workspaceId: number, surveyId: number, projectUserId: number)
{
	return {
		'$type': 'TCh.Domain.Evaluation.Estimations.Queries.PanelistMeetingPageQueryV1, TCh.Domain.Evaluation',
		'WorkspaceId': workspaceId,
		'SurveyId': surveyId,
		'ProjectUserId': projectUserId
	}
}



export function buildExportAllVotesQueryV1(workspaceId: number, projectId: number, evalModelId: number)
{
	return {
		'$type': 'TCh.Domain.Evaluation.Estimations.Queries.ExportAllVotesQueryV1, TCh.Domain.Evaluation',
		'WorkspaceId': workspaceId,
		'ProjectId': projectId,
		'EvalModelId': evalModelId,
	}
}

export function buildExportAllDisagreementsQueryV1(workspaceId: number, projectId: number, evalModelId: number)
{
	return {
		'$type': 'TCh.Domain.Evaluation.Estimations.Queries.ExportAllDisagreementsQueryV1, TCh.Domain.Evaluation',
		'WorkspaceId': workspaceId,
		'ProjectId': projectId,
		'EvalModelId': evalModelId,
	}
}

export function buildExportAccessLinksBySurveyIdQueryV1(workspaceId: number, surveyId: number)
{
	return {
		'$type': 'TCh.Domain.Evaluation.Estimations.Queries.ExportAccessLinksBySurveyIdQueryV1, TCh.Domain.Evaluation',
		'WorkspaceId': workspaceId,
		'SurveyId': surveyId
	}
}

export function buildExportPanelistVotesQueryV1(workspaceId: number, surveyId: number, projectUserId: number)
{
	return {
		'$type': 'TCh.Domain.Evaluation.Estimations.Queries.ExportPanelistVotesQueryV1, TCh.Domain.Evaluation',
		'WorkspaceId': workspaceId,
		'SurveyId': surveyId,
		'ProjectUserId': projectUserId
	}
}



export function buildPanelQueryV1(workspaceId: number, surveyId: number)
{
	return {
		'$type': 'TCh.Domain.Evaluation.Estimations.Queries.PanelQueryV1, TCh.Domain.Evaluation',
		'WorkspaceId': workspaceId,
		'SurveyId': surveyId,
	}
}

export function buildPanelByNameQueryV1(workspaceId: number, evalModelId: number, name: string)
{
	return {
		'$type': 'TCh.Domain.Evaluation.Estimations.Queries.PanelByNameQueryV1, TCh.Domain.Evaluation',
		'WorkspaceId': workspaceId,
		'EvalModelId': evalModelId,
		'Name': name,
	}
}

export function buildPanelistsQueryV1(workspaceId: number, surveyId: number)
{
	return {
		'$type': 'TCh.Domain.Evaluation.Estimations.Queries.PanelistsQueryV1, TCh.Domain.Evaluation',
		'WorkspaceId': workspaceId,
		'SurveyId': surveyId,
	}
}

export function buildPanelistQueryV1(workspaceId: number, surveyId: number, projectUserId: number)
{
	return {
		'$type': 'TCh.Domain.Evaluation.Estimations.Queries.PanelistQueryV1, TCh.Domain.Evaluation',
		'WorkspaceId': workspaceId,
		'SurveyId': surveyId,
		'ProjectUserId': projectUserId
	}
}


export function buildHostActiveQuestionQueryV1(workspaceId: number, surveyId: number, questionId: string)
{
	return {
		'$type': 'TCh.Domain.Evaluation.Estimations.Queries.HostActiveQuestionQueryV1, TCh.Domain.Evaluation',
		'WorkspaceId': workspaceId,
		'SurveyId': surveyId,
		'QuestionId': questionId,
	}
}

export function buildPanelistVoteQueryV1(workspaceId: number, projectUserId: number, questionId: string)
{
	return {
		'$type': 'TCh.Domain.Evaluation.Estimations.Queries.PanelistVoteQueryV1, TCh.Domain.Evaluation',
		'WorkspaceId': workspaceId,
		'ProjectUserId': projectUserId,
		'QuestionId': questionId,
	}
}


export function buildDisagreementsQueryV1(workspaceId: number, surveyId: number)
{
	return {
		'$type': 'TCh.Domain.Evaluation.Estimations.Queries.DisagreementsQueryV1, TCh.Domain.Evaluation',
		'WorkspaceId': workspaceId,
		'SurveyId': surveyId,
	}
}


